import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class SubscribersImportAccessRight {
  public static VIEW_IMPORT_SUBSCRIBERS_LIST: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
  public static REMOVE_US_MERCHANTS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
}
